import React, { createContext, useState } from "react";

export const SearchVocContext = createContext({});

export const initialSearchValues = {
  customerGroupByAge: "",
  lineOfWorkName: [],
  quarter:"",
  yearOfBudget:"",
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  total: 0,
  totalPage: 0,
  // sortBy: "departmentId",
  // sortDirection: "ASC",
};

const SearchVocProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchVocContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchVocContext.Provider>
  );
};

export default SearchVocProvider;
